import React, { useState, useLayoutEffect, useEffect } from "react";

/** Components */
import { Button, TablePagination, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import { ticketStatusOptions } from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getCustomers, getInventory, getRPTTotalInv } from "../../../services/api";
import { convertQueryStringToObject, fitToColumn } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { statusColor } from "../../config";
import { ExcelIcon } from "../../commons/miscellaneous";
import * as XLSX from "xlsx";
import { useDispatch } from "react-redux";

export default function RPTTotalInvByBranch() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  // custom hook
  const location = useLocation();
  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading, filter } = useParamFilter({ page: 1, per_page: 50 }, getRPTTotalInv);
  // state
  const [input, setInput] = useState({
    start_date: filter.start_date,
    end_date: filter.end_date,
    customer: null,
    status: null,
    inventory: null,
  });
  const [exportError, setExportError] = useState(false);

  const handleSearch = () => {
    fetchData((prev) => ({ ...input, inventory: null, inventory_id: input.inventory?.id, status: input.status, customer_id: input.customer?.id, customer: null }));
  };
  const handleClickDownloadCSV = () => {
    const params = {};
    setExportError(false);
    if (input.start_date && input.end_date) {
      const start_date = new Date(input.start_date);
      const end_date = new Date(input.end_date);
      const startQuarter = Math.floor(start_date.getMonth() / 3);
      const endQuarter = Math.floor(end_date.getMonth() / 3);
      const startYear = start_date.getFullYear();
      const endYear = end_date.getFullYear();
      if (startQuarter !== endQuarter || startYear !== endYear) {
        setExportError(true);
        return false;
      }
    } else {
      setExportError(true);
      return false;
    }
    if (input.start_date) params.start_date = input.start_date;
    if (input.end_date) params.end_date = input.end_date;
    if (input.customer) params.customer_id = input.customer.id;
    if (input.status) params.status = input.status;
    if (input.inventory) params.inventory_id = input.inventory.id;
    return getRPTTotalInv(params);
  };
  const exportExcel = (res) => {
    if (res.code === 200) {
      const arrayData = res.data.map((item) => ({
        // làm thế này để xác định những cột nào định dạng string trong file csv
        STT: item.id,
        "Ngày hóa đơn": item.valid_date ? new Date(item.valid_date) : "",
        "Ký hiệu": item.serial,
        "Số hóa đơn": item.code,
        "Mã tra cứu": item.fkey,
        "Khách hàng": item.customer_name,
        "Hãng hàng không": item.airline_name,
        "Kho xuất": item.inventory_code,
        "Phương thức bán": item.component,
        "Chuyến bay": item.flight_no,
        "Tuyến bay": item.route,
        "Số hiệu MB": item.code_aircraft,
        "Giờ bắt đầu": item.start_pump ? moment(item.start_pump).format("HH:mm") : "",
        "Giờ kết thúc": item.end_pump ? moment(item.end_pump).format("HH:mm") : "",
        "Nhiệt độ": +item.temp,
        "Tỷ trọng": +item.density,
        VCF: +item.vcf,
        WCF: +item.wcf,
        D15: +item.d15,
        Gallon: +item.gallon,
        LTT: +item.lit,
        L15: +item.l15,
        KG: +item.kg,
        "Số xe tra nạp": item.refueler_no,
        "Nhân viên tra nạp": item.name,
        "Trạng thái": item.status ? t(item.status) : "",
      }));
      const worksheet = XLSX.utils.json_to_sheet(arrayData);
      // Đặt định dạng datetime cho cột B
      arrayData.forEach((item, index) => {
        const cellAddress = XLSX.utils.encode_cell({ r: index + 1, c: 1 }); // Cột B, hàng thứ (index + 1)
        worksheet[cellAddress].z = "dd/mm/yyyy";
      });
      worksheet["!cols"] = fitToColumn(arrayData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet);
      XLSX.writeFileXLSX(workbook, "bchdtcn.xlsx");
    }
  };
  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("BẢNG KÊ CHI TIẾT CHỨNG TỪ TẠI CHI NHÁNH"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          {exportError && <span style={{ display: "flex", marginRight: 10, alignItems: "Center", color: "red", fontWeight: "bold" }}>Vui lòng xuất dữ liệu trong một quý</span>}
          <ButtonWithAPICall disableSnackbar={() => true} response={exportExcel} api={handleClickDownloadCSV} style={{ display: Boolean(data.length) ? "" : "none" }}>
            <ExcelIcon />
          </ButtonWithAPICall>

          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <SearchIcon />
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.customer || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
            label={t("Khách hàng")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == filter.customer_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.customer_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getInventory({ status: 1 })}
            value={input.inventory}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, inventory: newValue }))}
            label={t("Kho hàng")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, inventory: option.find((item) => item.id == filter.inventory_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.inventory_id]}
          />
          <CustomDatePicker label={t("Từ ngày")} value={input.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <CustomDatePicker label={t("Đến ngày")} value={input.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <FilterBy
            style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
            label={t("Trạng thái")}
            getOptionLabel={(option) => t(option) || ""}
            isOptionEqualToValue={(option, value) => option === value}
            getDataFunc={() => Promise.resolve({ data: ticketStatusOptions, code: 200 })}
            value={input?.status || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, status: newValue }))}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, status: option.find((item) => item == filter.status) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.status]}
          />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "100%" }}>
              <Table>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      STT
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Ngày hóa đơn
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Ký hiệu
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Số hóa đơn
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Mã tra cứu
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", minWidth: 200 }}>
                      Khách hàng
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", minWidth: 200 }}>
                      Hãng hàng không
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Kho xuất
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Phương thức bán
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Chuyến bay
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Tuyến bay
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Số hiệu MB
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Giờ bắt đầu
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Giờ kết thúc
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Nhiệt độ
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Tỷ trọng
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      VCF
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      WCF
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      D15
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Gallon
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      LTT
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      L15
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      KG
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Thử nước
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Số xe tra nạp
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Nhân viên tra nạp
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Trạng thái
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {index + (+filter.page - 1) * filter.per_page + 1}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.valid_date && moment(item.valid_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.serial}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.code}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.fkey}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="left">
                          {item.customer_name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="left">
                          {item.airline_name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.inventory_code}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.component}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.flight_no}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.route}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.code_aircraft}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.start_pump && moment(item.start_pump).format("HH:mm")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.end_pump && moment(item.end_pump).format("HH:mm")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.temp?.toFixed(2)}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.density?.toFixed(4)}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.vcf?.toFixed(4)}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.wcf?.toFixed(4)}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.d15?.toFixed(4)}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.gallon?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.lit?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.l15?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.kg?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.chk_water ? <DoneIcon color="success" fontSize="small" /> : <CloseIcon color="error" fontSize="small" />}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray", whiteSpace: "nowrap" }} align="center">
                          {item.refueler_no}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray", color: statusColor[item.status], whiteSpace: "nowrap" }} align="center" className={`status ${item.status}`}>
                          {t(item.status)}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={50}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  );
}
